<template>
  <div>
    <NewHeader />
    <div class="container mb-5 mt-5">
      <h5 class="text-center">SOCIETIES</h5>

      <div class="society-wrapper">
        <div v-for="(society, societyIndex) in churchSociety" :key="societyIndex">

          <figure>
            <img :src= society.imgSrc :alt= society.alt width="200px" height="200px">
          </figure>

          <figcaption>{{society.name}}</figcaption>
          <p><small>{{society.meetingDays}}</small></p>
          <p><small>Time: {{society.time}}</small></p>

        </div>

      </div>

      <div class="text-center mt-4">
        <button class="btn btn-primary">Join A Society</button>

      </div>

    </div>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/navigation/Header.vue';
import Footer from '@/components/navigation/Footer.vue';
import NewHeader from '@/components/navigation/NewHeader.vue';
import { societies } from '@/Data/society.js';

export default {
  data() {
    return {
      churchSociety: []
    }

  },
  components: {
    Header,
    Footer,
    NewHeader
  },
  created() {
    societies.forEach((society) => {
      this.churchSociety.push(society)
    })
  }
};
</script>

<style scoped>
.society-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 1.25rem;
}
p{
  margin: 0;
}
</style>
